function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "logotipos"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "120.78 44.09 96.63 2.25 72.47 44.09 48.31 85.93 24.16 127.77 72.47 127.77 96.63 85.93 120.78 127.77 169.1 127.77 144.94 85.93 120.78 44.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.31 169.61 24.16 127.77 0 169.61 48.31 169.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "96.63 169.61 120.78 127.77 72.47 127.77 96.63 169.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "193.25 169.61 169.1 127.77 144.94 169.61 193.25 169.61"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M896.07,2.12H933L857.73,169.61H828.32L753,2.12h38.11l52.23,121.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M946.18,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1038.51,166.67q-17.54-5.05-29-14.23l11.76-26.35A92.28,92.28,0,0,0,1075.33,143q16,0,24.58-5.06t8.58-14.23q0-8-7.88-12.59T1073,102.33q-22.11-4.45-35.17-10.94t-19-15.76q-6-9.28-6-23.17a46.2,46.2,0,0,1,8.35-27q8.36-12,23.41-18.7T1079.33,0a113.9,113.9,0,0,1,34.34,5.18q16.47,5.18,26.35,14.11l-11.76,26.35q-22.12-16.93-48.7-16.94-14.11,0-22.58,5.65t-8.47,15.29a14.13,14.13,0,0,0,3.17,9.41q3.18,3.77,10.71,6.7t21.4,5.76q32.24,7.06,46.47,18.35t14.23,30.82q0,23.53-18.35,37.29t-51.05,13.76A131.33,131.33,0,0,1,1038.51,166.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1171.07,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1274.93,161.26a70.56,70.56,0,0,1-28.46-30q-10-19.53-10-45.64t10-45.4a70.9,70.9,0,0,1,28.46-29.76Q1293.4,0,1318.33,0t43.29,10.47a70.44,70.44,0,0,1,28.23,29.76q9.89,19.29,9.88,45.4t-9.88,45.64a70.11,70.11,0,0,1-28.23,30q-18.34,10.47-43.29,10.47T1274.93,161.26Zm76.46-33q11.86-14.82,11.88-42.58t-11.88-42.34q-11.88-14.59-33.06-14.59t-33,14.59q-11.88,14.58-11.88,42.34,0,28,11.88,42.7t33,14.7Q1339.51,143,1351.39,128.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1535,2.12h34.59V169.61h-27.29l-83.51-106.8v106.8h-34.35V2.12h27L1535,108.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M210,169.61V2.12h36.69V139.74h74.81v29.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M343.81,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M536.94,2.12h36.94L498.6,169.61H469.19L393.91,2.12H432l52.23,121.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M587.05,169.61V2.12h115.5V30.58H622.81V70.11h74.8V98.8h-74.8v42.35h79.74v28.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1110,308.62v-85.8h15.54v85.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1143,308.62V265q0-4.33-.18-8.67t-.78-8.56h14.22l1.32,12.05-1.32.36a21.83,21.83,0,0,1,8.61-10.42,24.52,24.52,0,0,1,13.2-3.55q21.69,0,21.69,25.06v37.36h-15.06V271.86q0-7.11-2.78-10.42t-8.55-3.31q-7,0-11.15,4.39T1158,274.15v34.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1273.82,308.62H1259V293.19l1.45,2.17a18.3,18.3,0,0,1-7.77,10.42,24.27,24.27,0,0,1-13.44,3.68,25.39,25.39,0,0,1-14-3.92,25.85,25.85,0,0,1-9.46-11.14,43.37,43.37,0,0,1-.06-33.38,25.08,25.08,0,0,1,9.46-11,26,26,0,0,1,14.1-3.85,23.5,23.5,0,0,1,13.44,3.85,19.13,19.13,0,0,1,7.77,10.37l-1.69,1.8V219.93h15.06Zm-30.48-10.73q7.47,0,11.57-5.18t4.09-14.82q0-9.52-4.09-14.7T1243.34,258q-7.59,0-11.81,5.12t-4.22,14.52q0,9.64,4.22,14.94T1243.34,297.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1312.14,309.46q-11.21,0-16.81-6.21t-5.6-18.73V247.76h15.06v36.88q0,6.63,2.77,9.76t8.32,3.13a13.7,13.7,0,0,0,10.6-4.34q4-4.33,4-11.57V247.76h15.18v60.86h-14.7V296.08l1.56-.12a20.61,20.61,0,0,1-8,10.06A22.3,22.3,0,0,1,1312.14,309.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1384.2,309.46q-16.64,0-26.27-7.59l4.22-10.61a35.23,35.23,0,0,0,10.48,5.43,38.76,38.76,0,0,0,11.81,1.8c3.69,0,6.51-.6,8.43-1.8a5.69,5.69,0,0,0,2.9-5.07,5.33,5.33,0,0,0-2-4.39c-1.37-1.09-3.7-2-7-2.84l-10.12-2.28q-8.33-1.82-12.48-6.09a15,15,0,0,1-4.15-10.9,16.21,16.21,0,0,1,3.13-9.83,20.51,20.51,0,0,1,8.8-6.68A33.22,33.22,0,0,1,1385,246.2a39.83,39.83,0,0,1,12.53,2,31.67,31.67,0,0,1,10.49,5.73l-4.34,10.36a34.5,34.5,0,0,0-9.34-5.18,28.29,28.29,0,0,0-9.46-1.69c-3.45,0-6.14.65-8.07,1.93a6.05,6.05,0,0,0-2.89,5.3,5.39,5.39,0,0,0,1.74,4.22q1.75,1.57,6.09,2.53l10.24,2.53q9,1.93,13.2,6.21t4.15,11.26a15.45,15.45,0,0,1-6.75,13.2Q1395.88,309.46,1384.2,309.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1414.08,259.09V247.76H1457v11.33Zm42.9,37V308a22.88,22.88,0,0,1-4.76,1.15,39.53,39.53,0,0,1-5,.3q-10.24,0-15.85-5.78t-5.6-16.63V232.94l15.06-5.06v58.44a13.1,13.1,0,0,0,1.33,6.45,7.41,7.41,0,0,0,3.55,3.31,12.39,12.39,0,0,0,5,1,18.47,18.47,0,0,0,3-.24A32.55,32.55,0,0,0,1457,296.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1467.22,308.62V265q0-4.22-.18-8.61a86.52,86.52,0,0,0-.78-8.62h14.22l1.69,15.67-1.69-.85q1.56-8.07,7.11-12.17a20.54,20.54,0,0,1,12.53-4.09,22.26,22.26,0,0,1,3.37.24,12.79,12.79,0,0,1,2.78.72L1506,261a20.25,20.25,0,0,0-8-1.57,16.33,16.33,0,0,0-8.86,2.17,13.87,13.87,0,0,0-5.18,5.84,19.12,19.12,0,0,0-1.74,8.26v32.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1537.84,312.59l-28.08-64.83h15.78l19.16,47.72ZM1516.75,336l-3.38-11.57a49.92,49.92,0,0,0,9.4-2.83,19.43,19.43,0,0,0,6.21-4.16,21.08,21.08,0,0,0,4.16-6.5l4.33-9.89,3.86-5.54,19.52-47.72h14.94l-28.19,64.95a43.31,43.31,0,0,1-8.08,12.72,30.93,30.93,0,0,1-10.3,7.17A50.55,50.55,0,0,1,1516.75,336Z"
})));

function SvgAliveVisionIndustryWhiteLogomarca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1575.79 335.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alive_vision_Industry_whiteLogomarca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliveVisionIndustryWhiteLogomarca);
export default __webpack_public_path__ + "static/media/alive_vision_Industry_whiteLogomarca.34ddbe2a.svg";
export { ForwardRef as ReactComponent };